// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".51c95897a33e718adf142d9a5f4cf58219377409.chunk.bundle.js";
};